/* ShubVibes — editorial interactions (progressive enhancement, no dependencies) */
(function () {
  'use strict';

  /* Reveal-on-scroll ------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.sv-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Recently viewed (localStorage) ----------------------------------------
     A product page records its handle; the "Recently viewed" section reads
     the list via [data-sv-recently-viewed] and fetches card markup. */
  function recordRecentlyViewed() {
    var meta = document.querySelector('[data-sv-product-handle]');
    if (!meta) return;
    var handle = meta.getAttribute('data-sv-product-handle');
    if (!handle) return;
    var key = 'sv:recently-viewed';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 8);
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  function renderRecentlyViewed() {
    var host = document.querySelector('[data-sv-recently-viewed]');
    if (!host) return;
    var current = host.getAttribute('data-current-handle') || '';
    var key = 'sv:recently-viewed';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h && h !== current; }).slice(0, 4);
    if (!list.length) { host.closest('[data-sv-recently-section]')?.remove(); return; }

    var section = host.closest('[data-sv-recently-section]');
    var track = host.querySelector('[data-sv-rv-track]') || host;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + h + '?section_id=sv-recently-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks.join('');
      if (html.trim()) {
        track.innerHTML = html;
        if (section) section.removeAttribute('hidden');
      } else if (section) {
        section.remove();
      }
    });
  }

  /* Wishlist stub (localStorage) — "Save to Wishlist" ---------------------- */
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sv-wishlist]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-sv-wishlist');
      var key = 'sv:wishlist';
      var list = [];
      try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (err) { list = []; }
      var i = list.indexOf(id);
      if (i > -1) { list.splice(i, 1); btn.classList.remove('is-saved'); btn.setAttribute('aria-pressed', 'false'); }
      else { list.push(id); btn.classList.add('is-saved'); btn.setAttribute('aria-pressed', 'true'); }
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (err) {}
      var label = btn.querySelector('[data-sv-wishlist-label]');
      if (label) label.textContent = i > -1 ? 'Save to Wishlist' : 'Saved to Wishlist';
    });
  }

  function init() {
    initReveal();
    recordRecentlyViewed();
    renderRecentlyViewed();
    initWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
